import React from 'react';
export default class ModernResumeSummary extends React.Component{
    render(){
        return  <div data-v-37c786be="" className="section">
					<div data-v-37c786be="" className="section-left">
                    	<div data-v-37c786be="" className="section-headline">{this.props.title}</div>
					</div>
					<div data-v-37c786be="" className="section-right">
                    	<div data-v-37c786be="" className="section-description" dangerouslySetInnerHTML={{ __html: this.props.data.description }}></div>
					</div>
                </div>
    }
}